export const Solutions = [
   {
      id: 1,
      name: 'Sales Solutions',
      description:
         'Sell everywhere with connected POS, ecommerce, and CRM. Create quotes, convert to invoices, and track revenue from lead to cash with AKAS.',
      images: [],
      backgroundImage: '/images/backgrounds/crm.jpeg',
      mainFeatures: [
         {
            icon: '🧾',
            title: 'Quotations & Invoicing',
            description:
               'Build itemized quotations with taxes, discounts, and payment terms; convert to invoices in one click and collect payments faster.',
            images: [],
         },
         {
            icon: '🛒',
            title: 'Point of Sale (POS)',
            description:
               'Speed up checkout with barcode scanning, printable/emailed receipts, hold and resume carts, cash drawer reconciliation, and offline-first resilience.',
            images: [],
         },
         {
            icon: '🏪',
            title: 'Ecommerce & Catalog',
            description:
               'Publish product catalogs with pricing tiers, manage stock availability, and sync orders from web, marketplace, and in-store channels.',
            images: [],
         },
         {
            icon: '🔄',
            title: 'Sales Pipeline & CRM',
            description:
               'Capture leads from web forms, track opportunities, schedule follow-ups, and trigger automated handoffs to billing and fulfillment.',
            images: [],
         },
         {
            icon: '📦',
            title: 'Inventory & Fulfillment',
            description:
               'Track stock by location, reserve inventory on confirmed orders, and manage picking, packing, and shipping updates in one place.',
            images: [],
         },
         {
            icon: '📈',
            title: 'Sales Reporting',
            description:
               'Monitor revenue, margins, taxes, and channel performance with dashboards that mirror the KPIs documented in AKAS sales reports.',
            images: [],
         },
      ],
      meta: {
         title: 'AKAS | Sales solutions for Cambodia',
         description:
            'Run quotations, invoices, POS, ecommerce, and CRM in one AKAS sales platform. Sell in-store and online with centralized products, inventory, and reporting.',
         keywords:
            'Sales Solution, POS, Ecommerce, CRM, Quotations, Invoicing, AKAS',
      },
      additionalFeatures: [
         {
            icon: '✓',
            title: 'Approval workflow',
            description:
               'Route discounts, credit notes, and large deals for approval before they post.',
         },
         {
            icon: '🌐',
            title: 'Multi-language & currency',
            description:
               'Support Khmer and English with multi-currency pricing and tax rules.',
         },
         {
            icon: '⚡',
            title: 'Offline-capable POS',
            description:
               'Keep selling during connectivity drops and sync when back online.',
         },
         {
            icon: '🔌',
            title: 'Integrations',
            description:
               'Connect payment gateways, barcode scanners, printers, and AKAS add-ons.',
         },
         {
            icon: '🔔',
            title: 'Notifications',
            description:
               'Alert sales, finance, and operations teams on key order and payment events.',
         },
         {
            icon: '📝',
            title: 'Audit logging',
            description:
               'Track user actions across quotations, invoices, and POS sessions.',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'Faster quote-to-cash',
            description:
               'Convert leads to invoices quickly with guided approvals and automated handoffs.',
         },
         {
            number: '02',
            title: 'Omnichannel control',
            description:
               'Keep POS, ecommerce, and B2B orders in sync with one product and inventory source.',
         },
         {
            number: '03',
            title: 'Reduced errors',
            description:
               'Standardize pricing, taxes, and stock reservations to cut rework and shrinkage.',
         },
         {
            number: '04',
            title: 'Better customer experience',
            description:
               'Give buyers consistent pricing, faster checkout, and clear order updates.',
         },
      ],
      videos: [],
   },
   {
      id: 2,
      name: 'Inventory Solutions',
      description:
         'Control stock across warehouses, keep counts accurate, and replenish on time with AKAS inventory.',
      images: [],
      backgroundImage: '/images/solutions/inventory-solution.jpg',
      mainFeatures: [
         {
            icon: '📦',
            title: 'Multi-location inventory',
            description:
               'Track on-hand, reserved, and available-to-promise by warehouse, store, or bin.',
            images: [],
         },
         {
            icon: '🔄',
            title: 'Stock movements',
            description:
               'Receive, transfer, and adjust stock with approval trails and variance notes.',
            images: [],
         },
         {
            icon: '🧾',
            title: 'Purchasing & replenishment',
            description:
               'Raise POs from reorder points and lead times; match receipts to supplier bills.',
            images: [],
         },
         {
            icon: '🚚',
            title: 'Fulfillment',
            description:
               'Pick, pack, and ship against sales orders with status updates to sales and finance.',
            images: [],
         },
         {
            icon: '🏷️',
            title: 'Lot / serial tracking',
            description:
               'Capture batch/serial numbers and expirations for traceability and recalls.',
            images: [],
         },
         {
            icon: '📈',
            title: 'Inventory analytics',
            description:
               'Monitor turnover, aging, valuation, and shrinkage with dashboards aligned to AKAS reports.',
            images: [],
         },
      ],
      meta: {
         title: 'AKAS | Inventory solutions for Cambodia',
         description:
            'Control stock across warehouses, keep counts accurate, and replenish on time with AKAS inventory.',
         keywords:
            'Inventory Solution, Stock Control, Warehouse, Replenishment, AKAS',
      },
      additionalFeatures: [
         {
            icon: '✅',
            title: 'Cycle counts & audits',
            description:
               'Run scheduled counts and reconcile variances with approvals.',
         },
         {
            icon: '📡',
            title: 'Barcode & scanners',
            description:
               'Speed receiving and picking with barcode-friendly workflows.',
         },
         {
            icon: '🔔',
            title: 'Alerts',
            description:
               'Get notified on low stock, backorders, and delayed receipts.',
         },
         {
            icon: '🔌',
            title: 'Integrations',
            description:
               'Connect POS, ecommerce, procurement, and accounting modules.',
         },
         {
            icon: '📝',
            title: 'Audit logging',
            description: 'Capture who adjusted stock, when, and why.',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'Inventory accuracy',
            description:
               'Reduce stockouts and overstock with real-time, multi-location visibility.',
         },
         {
            number: '02',
            title: 'Faster fulfillment',
            description:
               'Pick, pack, and ship faster with guided workflows tied to sales orders.',
         },
         {
            number: '03',
            title: 'Lower carrying costs',
            description:
               'Replenish based on demand and lead times to cut excess stock.',
         },
         {
            number: '04',
            title: 'Compliance & traceability',
            description:
               'Lot/serial control and audit trails simplify recalls and inspections.',
         },
      ],
      videos: [],
   },
];
